import angular from 'angular';

angular
  .module('cxSettings')
  .controller('TaskTemplateTagsDialogCtrl', [
    '$filter',
    'flySvc',
    '$element',
    'close',
    'appUrls',
    '$http',
    'taskTemplateId',
    'tags',
    taskTemplateTagsDialogCtrl,
  ]);

function taskTemplateTagsDialogCtrl(
  $filter,
  flySvc,
  $element,
  close,
  appUrls,
  $http,
  taskTemplateId,
  tags,
) {
  var vm = this;
  vm.tags = [];
  vm.taskTemplateId = taskTemplateId;
  vm.orgSelectedTags = angular.copy(tags || []);
  vm.selectedTags = angular.copy(tags || []);
  vm.removedTags = '';
  vm.propagate = true;
  vm.hasChanged = false;
  vm.saving = false;

  var showError = function(error) {
    flySvc.error(error);
    return '';
  };

  $http.get(`${appUrls.tasks}/api/Tags/`).then(function({ data }) {
    vm.tags = data;
  }, showError);

  vm.filterTags = function(search) {
    return $filter('filter')(vm.tags, search);
  };

  vm.tagsChanged = function() {
    vm.removedTags = vm.orgSelectedTags
      .filter(x => !vm.selectedTags.some(t => !!t.id && x.id === t.id))
      .map(x => x.name)
      .join(', ');
    vm.hasChanged =
      vm.selectedTags.length !== vm.orgSelectedTags.length ||
      JSON.stringify(vm.selectedTags.map(x => x.name).sort()) !==
        JSON.stringify(vm.orgSelectedTags.map(x => x.name).sort());
  };

  vm.save = function() {
    if (vm.saving) return;
    if (!vm.hasChanged) return vm.cancel();

    vm.saving = true;
    return $http
      .post(`${appUrls.tasks}/api/TaskTemplates/Tags/${taskTemplateId}`, {
        tags: vm.selectedTags,
        propagate: vm.propagate,
      })
      .then(
        ({ data }) => {
          vm.saving = false;
          $element.modal('hide');
          close(data, 500);
        },
        error => {
          showError(error);
          vm.saving = false;
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
